import { getCookieConsent } from 'providers/CookieConsentProvider';
import Logger from 'utils/Logger';

const REGIONS_DENY_DEFAULT = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'GB',
  'US-CA',
];

function init() {
  Logger.logAnalytics('[GA4] init');

  const GA4PropertyId =
    ENVIRONMENT === 'production' ? 'G-8V4J1MY5HV' : 'G-R767G5RSGD';
  const googleAdsMeasurementIds =
    ENVIRONMENT === 'production' ? ['AW-979459470', 'AW-16898505741'] : [];
  const firstPartyTagging = `, {
    "transport_url": "https://tag.withlocals.com",
    "first_party_collection": true,
    }`;

  Logger.logAnalytics('[GA4] GA4PropertyId', GA4PropertyId);

  const gtagScriptElement = document.createElement('script');
  gtagScriptElement.src = `https://www.googletagmanager.com/gtag/js?id=${GA4PropertyId}&l=ga4Layer`;
  gtagScriptElement.async = true;
  document.head.appendChild(gtagScriptElement);

  const cookieConsent = getCookieConsent();

  const advertisementCookie = cookieConsent.advertisement;
  const personalizationCookie = cookieConsent.personalised_ads;
  const analyticsCookie = cookieConsent.analytics;

  const updateObject = Object.assign({});
  if (advertisementCookie && personalizationCookie) {
    updateObject.ad_storage =
      advertisementCookie === true || personalizationCookie === true
        ? 'granted'
        : 'denied';
  }

  if (analyticsCookie) {
    updateObject.analytics_storage =
      analyticsCookie === true ? 'granted' : 'denied';
  }

  if (advertisementCookie) {
    updateObject.ad_user_data =
      advertisementCookie === true ? 'granted' : 'denied';
  }

  if (personalizationCookie) {
    updateObject.ad_personalization =
      personalizationCookie === true ? 'granted' : 'denied';
  }

  const gtagSetupScriptElement = document.createElement('script');
  gtagSetupScriptElement.innerHTML = `
      window.ga4Layer = window.ga4Layer || [];
      window.dataLayer = window.dataLayer || [];

      function ga4Tag() { ga4Layer.push(arguments); }
      function gtag() { dataLayer.push(arguments); }
      
      ga4Tag('consent', 'default', {
        'analytics_storage': 'denied',
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'region': ${JSON.stringify(REGIONS_DENY_DEFAULT)},
      });  
      ga4Tag('consent', 'default', {
        'analytics_storage': 'granted',
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted',
      });
      ga4Tag('consent', 'update', ${JSON.stringify(updateObject)});

      ga4Tag('js', new Date());
      ga4Tag('config', '${GA4PropertyId}'${
        ENVIRONMENT === 'production' ? firstPartyTagging : ''
      });
      ${googleAdsMeasurementIds
        .map((id) => `ga4Tag('config', '${id}')`)
        .join(';')}
      
      gtag('consent', 'default', {
        'analytics_storage': 'denied',
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'region': ${JSON.stringify(REGIONS_DENY_DEFAULT)},
      });
      gtag('consent', 'default', {
        'analytics_storage': 'granted',
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted',
      });
      gtag('consent', 'update', ${JSON.stringify(updateObject)});

      ${googleAdsMeasurementIds
        .map((id) => `gtag('config', '${id}')`)
        .join(';')}
  `;
  document.head.appendChild(gtagSetupScriptElement);
}

export default {
  init,
};
